import * as types from '../mutation-types'
import api from '@/api/teamMember'
import settings from "@/settings";

// initial state
const state = {
  teamMembers: [],
  loaded: false,
  currentTeamMember: {}
}

const getters = {
  teamMembers: (state, getters) =>  {
    let flag = getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.TEAM_MEMBERS_ALPHABETICALLY)
    if(flag) {
      let teamMembers = JSON.parse(JSON.stringify(state.teamMembers))
      return teamMembers.sort((a,b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
    }
    return state.teamMembers
  },
  teamMembersLoaded: state => state.loaded,
  currentTeamMember: state => state.currentTeamMember
}

const actions = {
  getTeamMembers({ commit }) {
    commit(types.SET_TEAM_MEMBERS_LOADED, false );
    api.getTeamMembers( (response) => {
      commit(types.SET_TEAM_MEMBERS, response._embedded.TeamMember );
      commit(types.SET_TEAM_MEMBERS_LOADED, true );
    })
  },
  cleanTeamMembers({commit}) {
    commit(types.SET_TEAM_MEMBERS_LOADED, false );
    commit(types.SET_TEAM_MEMBERS, {} );
  },
  getTeamMember({ commit }, id) {
    api.getTeamMember(id, (response) => {
      commit(types.SET_TEAM_MEMBER, response)
    })
  }
}

const mutations = {
  [types.SET_TEAM_MEMBERS] (state, teamMembers ) {
    state.teamMembers = teamMembers
  },
  [types.SET_TEAM_MEMBERS_LOADED] (state, status ) {
    state.loaded = status
  },
  [types.SET_TEAM_MEMBER] (state, teamMember ) {
    teamMember = teamMember._total === 0 ? {} : teamMember._embedded.TeamMember[0]
    state.currentTeamMember = teamMember
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}


